export const FLSA_REPORT_STRINGS = {
  COLUMNS: {
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMPLOYEE_ID: "Employee ID",
    WEEK_START_DATE: "Week Start Date",
    WEEK_END_DATE: "Week End Date",
    QUALIFIED_OT: "Qualified OT",
    QUALIFIED_DT: "Qualified DT",
    TOTAL_QUALIFIED: "Total Qualified",
  },
  MESSAGES: {
    NO_RECORDS_FOUND: "No Records Found",
    SEARCH_ABOVE_FOR_RESULTS: "Search above for results",
  },
};
